import { useEffect } from "react";
import { useNotificationUnread } from "context/NotificationUnreadContext";
import { getRealtimeSocket } from "realtime/socketClient";

/**
 * Keeps notification unread badge count in sync via socket events.
 * Mounted alongside chat listener in the protected shell.
 */
export function NotificationUnreadSocketListener() {
  const { socketConnected, handleNotificationNewSocket } =
    useNotificationUnread();

  useEffect(() => {
    const s = getRealtimeSocket();
    if (!s || !socketConnected) return;
    s.on("notification:new", handleNotificationNewSocket);
    return () => {
      s.off("notification:new", handleNotificationNewSocket);
    };
  }, [socketConnected, handleNotificationNewSocket]);

  return null;
}
